/* ==========================================================
   DOCUMENT READY
   ========================================================== */
$(document).ready(function () {

  /* ======================================================
     WOW.js (Scroll Animations)
     ====================================================== */
  new WOW().init();


  /* ======================================================
     Sticky Header
     ====================================================== */
  window.addEventListener("scroll", function () {
    if (window.scrollY > 350) {
      document.body.classList.add("sticky-header");
    } else {
      document.body.classList.remove("sticky-header");
    }
  });


  /* ======================================================
     Mobile Menu Toggle
     ====================================================== */
  $(".menu-toggle-btn, .nav-logo-wrap .close-icon, .shadow-overlay").on("click", function () {
    $("body").toggleClass("nav-open overflow-hidden");
  });


  /* ======================================================
     Submenu Handling (Dynamic Arrow + Toggle)
     ====================================================== */
  // Add arrow icon + class to li containing <ul>
  $(".main-nav li:has(ul)")
    .append('<i class="icon vector-arrow"></i>')
    .addClass("has-submenu");

  // Mobile submenu toggle
  $(document).on("click", ".main-nav li.has-submenu", function (e) {
    if ($(window).width() <= 991) {
      // Toggle on clicking the arrow (icon) or if current item is clicked and it's not a link
      if ($(e.target).hasClass("vector-arrow") || ($(e.target).is("li") && !$(e.target).is("a"))) {
        e.preventDefault();
        $(this).toggleClass("show");
        $(this).children("ul").slideToggle("fast");
      }
    }
  });

  // Reset desktop submenus on resize
  $(window).on("resize", function () {
    if ($(window).width() > 991) {
      $(".main-nav li.has-submenu ul").removeAttr("style");
      $(".main-nav li.has-submenu").removeClass("show");
      $("body").removeClass("nav-open overflow-hidden");
    }
  });


  /* ======================================================
     Slider (Slick Slider)
     ====================================================== */
  $(".-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 800,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });


  /* ======================================================
     Back to Top Button
     ====================================================== */
  var $backToTopBtn = $(".back-to-top-btn");

  // Show/hide on scroll
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 400) {
      $backToTopBtn.addClass("show");
    } else {
      $backToTopBtn.removeClass("show");
    }
  });

  // Smooth scroll to top on click
  $backToTopBtn.on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 300);
  });



})  
